import { useMemo } from "react";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, AutocompleteAPI, FormField, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";
import useDataCommon from "hooks/useDataCommon.hook";

import Constants from "constants/index";
import { RootState } from "store";
import { Mode, Status } from "constants/enum";
import { ICodename, IDataDetailReport, IErrorReport } from "commons/interfaces";



const CardDescription = ({
    mode,
    data,
    error,
    dataOptionGroups,
    handleChangeValue,
}: {
    mode: Mode,
    error: IErrorReport;
    data: IDataDetailReport;
    dataOptionGroups: ICodename[];
    handleChangeValue: (key: string, value: any) => void;
}) => {

    const { getDataDepartments } = useDataCommon();

    const workingOrganization = useSelector((state: RootState) => state.user.workingOrganization);

    const requestGetApiGroup = useMemo(() => ({
        listStatus: [Status.Active],
        organizationId: workingOrganization || "0",
    }), [workingOrganization]);

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.REPORT.DESCRIPTION}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        required
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptionGroups}
                        defaultValue={data?.incidentPlace}
                        errorMessage={error?.incidentPlace}
                        label={Strings.REPORT.DEPARTMENT_INCIDENT}
                        placeholder={Strings.REPORT.SELECT_DEPARTMENT}
                        onChange={(val) => {
                            handleChangeValue("incidentPlace", val)
                        }}
                    />
                    {/* <AutocompleteAPI
                        mode={mode}
                        variant={"outlined"}
                        defaultValue={data?.incidentPlace}
                        errorMessage={error?.incidentPlace}
                        label={Strings.REPORT.DEPARTMENT_INCIDENT}
                        placeholder={Strings.REPORT.SELECT_DEPARTMENT}
                        dataSelected={data?.incidentPlace ? [{
                            code: data?.incidentPlace || "",
                            name: data?.incidentPlaceName || "",
                        }] : []}
                        getApi={getDataDepartments}
                        requestGetApi={requestGetApiGroup}
                        onChange={(val) => { }}
                        onChangeItem={(val) => {
                            handleChangeValue("incidentPlace", val)
                        }}
                    /> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        defaultValue={data?.detailPlace}
                        errorMessage={error?.detailPlace}
                        label={Strings.REPORT.DETAIL_PLACE}
                        placeholder={Strings.REPORT.ENTER_DETAIL_PLACE}
                        onBlur={(val) => {
                            handleChangeValue("detailPlace", val)
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        required
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={100}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        defaultValue={data?.shortDescription}
                        errorMessage={error?.shortDescription}
                        label={Strings.REPORT.SHORT_DESCRIPTION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        placeholder={Strings.REPORT.ENTER_SHORT_DESCRIPTION}
                        onBlur={(val) => {
                            handleChangeValue("shortDescription", val)
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={100}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        defaultValue={data?.firstSuggestedSolution}
                        errorMessage={error?.firstSuggestedSolution}
                        label={Strings.REPORT.FIRST_SUGGESTED_SOLUTION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        placeholder={Strings.REPORT.ENTER_FIRST_SUGGESTED_SOLUTION}
                        onBlur={(val) => {
                            handleChangeValue("firstSuggestedSolution", val)
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={100}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        defaultValue={data?.firstTreatment}
                        errorMessage={error?.firstTreatment}
                        label={Strings.REPORT.FIRST_TREATMENT + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        onBlur={(val) => {
                            handleChangeValue("firstTreatment", val)
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
}

export default CardDescription;